import { data } from '../../svg/MoreHoriz/data';
import { makeIcon } from '../makeIcon';

export const MoreHoriz = makeIcon(data, 'more_horiz', 'MoreHoriz');

export default MoreHoriz;
